/* Green Gorilla Fruits — toast
 * --------------------------------------------------------------
 * Lightweight toast controller bound to <div data-gg-toast> in
 * layout/theme.liquid. On page load, detects ?logged_out=1 and
 * shows the localized sign-out toast for 5 seconds. This module
 * is the sole owner of the `logged_out` query parameter — it is
 * stripped via history.replaceState immediately after read.
 *
 * Public API: window.GG_Toast.show(message, { duration }) / .hide()
 */
(function () {
  'use strict';

  const TOAST_DURATION = 5000;

  function init() {
    const root = document.querySelector('[data-gg-toast]');
    if (!root) return;
    if (root.dataset.ggToastInit === '1') return;
    root.dataset.ggToastInit = '1';

    let timerId = null;

    function onKeydown(e) {
      if (e.key === 'Escape') hide();
    }

    function show(message, options) {
      const msgEl = root.querySelector('[data-gg-toast-message]');
      if (msgEl) msgEl.textContent = message;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      const duration = options && options.duration != null ? options.duration : TOAST_DURATION;
      if (timerId) clearTimeout(timerId);
      if (duration > 0) {
        timerId = setTimeout(hide, duration);
      }
      document.addEventListener('keydown', onKeydown);
    }

    function hide() {
      if (timerId) {
        clearTimeout(timerId);
        timerId = null;
      }
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKeydown);
    }

    const closeBtn = root.querySelector('[data-gg-toast-close]');
    if (closeBtn) closeBtn.addEventListener('click', hide);

    window.GG_Toast = { show, hide };

    let params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }
    if (params.get('logged_out') === '1') {
      const msg = root.getAttribute('data-gg-toast-logout-message') || '';
      if (msg) show(msg);
      params.delete('logged_out');
      const qs = params.toString();
      const newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
      try {
        history.replaceState(null, '', newUrl);
      } catch (e) {
        /* noop */
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
